<template>
  <div>
    <div class="row no-gutters align-items-center">
      <div class="col">
        <DoctorCard
          v-if="item.schedule && item.schedule.assignee"
          :doctor-id="item.schedule.assignee.id"
        ></DoctorCard>
      </div>
      <div class="col-auto p-3 text-center">
        <small>
          {{ item.created_at | moment("from", "now") }}
        </small>
        <template v-if="authType === 'Doctor' && activeCaseId && caseById(activeCaseId).status === 'active'">
        <a
          v-if="!hasReference(activeCaseId)(item.id)"
          href="#"
          class="d-block text-center nounderline pointer"
          @click.prevent="reference(item)"
        >
          {{ $t("reference") }}
        </a>
        <a
          v-else
          href="#"
          class="d-block text-center nounderline pointer"
          @click.prevent="unlinkReference(item)"
        >
          {{ $t("removeReference") }}
        </a>
        </template>
      </div>
    </div>
    <PatientCase :value="item.id"></PatientCase>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  components: {
    DoctorCard: () => import('@/components/DoctorCard.vue'),
    PatientCase: () => import('@/components/Cases/PatientCase.vue')
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    activeCaseId: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      authType: 'auth/type',
      hasReference: 'pcase/hasReference',
      refByCase: 'pcase/refByCase',
      caseById: 'pcase/byId'
    })
  },
  methods: {
    ...mapMutations({
      setError: 'alert/setError',
      pushReference: 'pcase/pushReference',
      removeReference: 'pcase/removeReference'
    }),
    async reference (item) {
      try {
        const params = {
          referenced_patient_case_id: item.id
        }
        const response = await this.axios.post(
          `/api/patient-cases/${this.activeCaseId}/references`,
          params
        )
        this.pushReference({ id: this.activeCaseId, ref: response.data.data })
      } catch (err) {
        this.setError(err)
      }
    },
    async unlinkReference (item) {
      const ref = this.refByCase(this.activeCaseId)(item.id)
      try {
        await this.axios.delete(
          `/api/patient-cases/${this.activeCaseId}/references/${ref.id}`
        )
        this.removeReference({ id: this.activeCaseId, refId: ref.id })
      } catch (err) {
        this.setError(err)
      }
    }
  }
}
</script>
<i18n>
{
  "ka": {
      "reference": "მიმაგრება",
      "removeReference": "მიმაგრების გაუქმება"
  }
}
</i18n>
